import { formatosDefault } from '@/commons/constants'
import Vue from "vue";

Vue.mixin({
    methods: {
        humanizarFormatoDataHora() {
            return formatosDefault.DATA_HORA_MINUTO
        },
        humanizarFormatoData() {
            return formatosDefault.DATA
        },
        humanizarFormatoHora() {
            return formatosDefault.HORA
        },
        // assume que a data recebida esta no timezone America/Sao_Paulo
        ehFuturo(data) {
            return this.moment(data).isAfter(agora(this))
        },
        // assume que a data recebida esta no timezone America/Sao_Paulo
        ehPresenteOuPassado(data) {
            return this.moment(data).isSameOrBefore(agora(this))
        }
    }
})

function agora(self) {
    return self.moment().tz(self.$store.state.loki.timezone)
}
